
import React from "react";
import { Schemes, Utils } from "../../../../../utils";
import { i18nManager } from "../../../../../i18n";
import { Elements } from "../../../../shared/Elements";
import { Siren } from "../../../../shared/ConfirmDialog";
import * as ReactRouterDom from "react-router-dom";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { BaseService, HostService, IHost, IHostWebsite, IMember, IProfileWebsite, ITeam, MemberService, SanitizedResponse } from "../../../../../services";
import { Button, ButtonManageRef, Checkbox, ComposedPassword, DateTimeInput, DateTimePicker, DOMHelper, Dropdown, Form, FormControl, NoseurObject, ObjectHelper, TabPane, TabPanel, TextAreaInput, TextInput } from "@rivtn/noseur";
import ImportExport from "../../../../page_design/ImportExport";
import MediaInput, { MediaInputManageRef } from "../../../../shared/MediaInput";

export interface PhysicalAddressProps {
    host: IHost;
    profile: IMember;
    hostWebsite: IHostWebsite;
}

function PhysicalAddress(props: PhysicalAddressProps) {

    const { host } = props;
    const hostService = HostService.getInstance();
    const labels = i18nManager.Labels.host.settings.about.phy_address;
    const [hostWebsite, setHostWebsite] = React.useState<IHostWebsite>(props.hostWebsite);

    return (<Form scheme={Schemes.OMNEHOST} className="profile-settings team-settings" style={{ padding: 0, boxShadow: "none", maxWidth: 600 }}>
        <p style={{ margin: "20px 0px" }}>{labels.address_1}</p>
        <FormControl isFieldset fill label={labels.address}>
            <TextInput defaultValue={hostWebsite.physical_addresses?.[0]?.address_line1} onInputComplete={(v) => {
                updateAddress(0, "address_line1", v);
            }} />
        </FormControl>
        <Dropdown noIcon fill scheme={Schemes.OMNEHOST} formControlProps={{ className: "plan-dd", isFieldset: true, label: labels.country, style: { marginTop: 10 } }}
            selectedOptionIndex={(i18nManager.CountriesAndCurrencies?.findIndex((p) => p?.value === (hostWebsite.physical_addresses?.[0]?.country ?? host.country_code ?? "NGA")) ?? 0)}
            textInputProps={{ style: { paddingLeft: 15 } }} options={i18nManager.CountriesAndCurrencies} onSelectOption={(o) => {
                updateAddress(0, "country", o.value);
            }} />
        <div style={{ display: "flex", marginTop: 20 }}>
            <FormControl isFieldset fill label={labels.city} style={{ flex: 1, marginRight: 10 }}>
                <TextInput defaultValue={hostWebsite.physical_addresses?.[0]?.city} onInputComplete={(v) => {
                    updateAddress(0, "city", v);
                }} />
            </FormControl>
            <FormControl isFieldset fill label={labels.state} style={{ flex: 1, marginLeft: 10 }}>
                <TextInput defaultValue={hostWebsite.physical_addresses?.[0]?.state} onInputComplete={(v) => {
                    updateAddress(0, "state", v);
                }} />
            </FormControl>
        </div>
        <p style={{ margin: "20px 0px", marginTop: 50 }}>{labels.address_2}</p>
        <FormControl isFieldset fill label={labels.address}>
            <TextInput defaultValue={hostWebsite.physical_addresses?.[1]?.address_line1} onInputComplete={(v) => {
                updateAddress(1, "address_line1", v);
            }} />
        </FormControl>
        <Dropdown noIcon fill scheme={Schemes.OMNEHOST} formControlProps={{ className: "plan-dd", isFieldset: true, label: labels.country, style: { marginTop: 10 } }}
            selectedOptionIndex={(i18nManager.CountriesAndCurrencies?.findIndex((p) => p?.value === (hostWebsite.physical_addresses?.[1]?.country ?? host.country_code ?? "NGA")) ?? 0)}
            textInputProps={{ style: { paddingLeft: 15 } }} options={i18nManager.CountriesAndCurrencies} onSelectOption={(o) => {
                updateAddress(1, "country", o.value);
            }} />
        <div style={{ display: "flex", marginTop: 20 }}>
            <FormControl isFieldset fill label={labels.city} style={{ flex: 1, marginRight: 10 }}>
                <TextInput defaultValue={hostWebsite.physical_addresses?.[1]?.city} onInputComplete={(v) => {
                    updateAddress(1, "city", v);
                }} />
            </FormControl>
            <FormControl isFieldset fill label={labels.state} style={{ flex: 1, marginLeft: 10 }}>
                <TextInput defaultValue={hostWebsite.physical_addresses?.[1]?.state} onInputComplete={(v) => {
                    updateAddress(1, "state", v);
                }} />
            </FormControl>
        </div>
        <Button scheme={Schemes.OMNEHOST} loadingProps={Elements.BUTTON_LOADING_PROPS} text={i18nManager.Labels.common.save_changes}
            style={{ marginTop: 50, padding: "10px 25px", }} onClick={(e) => updateHostSocialAccounts(e.manageRef)} />
    </Form>);

    function updateAddress(index: number, field: string, value: string) {
        if (!hostWebsite.physical_addresses?.length || hostWebsite.physical_addresses?.length < (index + 1)) {
            for (let i = 0; i < (index + 1); i++) {
                hostWebsite.physical_addresses.push({} as any);
            }
        }
        (hostWebsite.physical_addresses[index] as any)[field] = value;
        setHostWebsite({ ...hostWebsite });
    }

    function updateHostSocialAccounts(manageRef?: ButtonManageRef) {
        manageRef?.setLoadingState(true);
        hostService.updateHostWebsite(host.external_id, props.hostWebsite).then(({ sanitized }: SanitizedResponse<IHostWebsite>) => {
            Siren.alert(labels.update_successful);
        }).catch(BaseService.reportError).finally(() => manageRef?.setLoadingState(false));
    }

}

export default PhysicalAddress;
